import styled from "styled-components";

const ScrollingTextArea = styled.div<{
  $maxHeight?: string;
  $resize?: boolean;
  $height?: string;
  $backgroundColor?: string;
}>`
  ${({ $backgroundColor }) =>
    $backgroundColor ? `background-color: ${$backgroundColor};` : ""}
  overflow: auto;
  ${({ $resize = true, $maxHeight = "400px", $height = "400px" }) =>
    $resize
      ? `
        resize: vertical;
        min-height: 100px;
        height: ${$height};
        max-height: fit-content;
      `
      : `
        max-height: ${$maxHeight};
      `}
`;

export default ScrollingTextArea;
